import React, { Component } from "react";
import { Card, Dropdown, Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import {
  BILLED_MANUALLY,
  BILLING,
  CARD_PAY,
  MPESA,
  PAYSTACK,
  PURCHASE_LABEL,
  PURCHASE_LABEL_ERROR,
  SAFARICOM,
} from "../../../constants/types";
import CardForm from "../UserDetails/CardForm";
import CardListItem from "../UserDetails/CardListItem";
import LabelSummary from "./LabelSummary";
import {
  selectCard,
  getUserDetails,
  purchaseRateCard,
  updatePurchaseEmail,
  updateFileType,
  checkPendingRatePurchase,
  clearPurchaseStates,
  getAccounts,
  selectAddress,
  submitPaystackPin,
  submitPaystackOtp,
} from "../../actions";
import { applyMiddleware as dispatch } from "redux";
import FILETYPES from "../../../assets/file-types.json";
import { withRouter } from "react-router-dom";
import { clearApplicationContext } from "../../actions/ApplicationContextActions";
import MessageBlock from "../common/MessageBlock";
import { FiAlertCircle } from "react-icons/fi";
import CURRENCY_UNITS from "../../../assets/currency-units.json";
import * as ROUTES from "../../../constants/routes";
import ToolTip from "../common/ToolTip";
import { toMoneyFormat } from "../common/helpers";

class PurchaseLabel extends Component {
  state = {
    create: false,
    selectedWallet: this.props.accounts?.find(
      (account) => account.currency === this.props.selectedRate?.currency,
    ),
    hasEnoughBalance: false,
    pinInput: "",
    otpInput: "",
    retrying: false,
  };

  componentDidMount = () => {
    this.props.getAccounts();
    this.props.getUserDetails();
    this.props.updatePurchaseEmail(this.props.info?.email || "");
    if (!this.props.paymentCard && this.props.defaultCard) {
      this.props.selectCard(this.props.defaultCard, CARD_PAY, () => {
        return;
      });
    }
    if (this.props.paymentCard) {
      const card = this.props.cardList?.find(
        (card) => card.id === this.props.paymentCard.id,
      );
      const defaultCard = this.props.cardList?.find(
        (card) => card.is_default === true,
      );
      if (!card) {
        this.props.selectCard(null, CARD_PAY);
      }
      if (this.props.defaultCard?.id !== this.props.paymentCard?.id) {
        this.props.selectCard(defaultCard, CARD_PAY);
      }
    }

    this.props.selectAddress(this.props.senderAddress, BILLING);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.paymentCard !== this.props.paymentCard ||
      prevProps.fileType !== this.props.fileType
    ) {
      this.props.clearPurchaseStates();
    }

    if (
      this.props.accounts.length > 0 &&
      prevProps.accounts !== this.props.accounts
    ) {
      this.setState({
        selectedWallet: this.props.accounts?.find(
          (wallet) =>
            wallet.currency.toString().toLowerCase() ===
            this.props.selectedRate.currency.toString().toLowerCase(),
        ),
      });
    }
    if (
      this.state.retrying &&
      !this.props.nextAction &&
      !this.props.pendingRatePurchase
    ) {
      this.setState({ retrying: false });
      this.payWithCard();
    }

    if (prevState.selectedWallet !== this.state.selectedWallet) {
      const rateAmount = this.props.selectedRate?.discounted_amount
        ? parseFloat(this.props.selectedRate?.discounted_amount)
        : parseFloat(this.props.selectedRate?.amount);
      this.setState({
        hasEnoughBalance:
          !!this.state.selectedWallet &&
          parseFloat(this.state.selectedWallet?.balance) >= rateAmount,
      });
    }
  }

  componentWillUnmount() {
    this.props.clearPurchaseStates();
    this.props.selectAddress(this.props.defaultAddress, BILLING);
  }

  retryPurchase = () => {
    this.props.clearPurchaseStates();
    this.setState({ retrying: true });
  };

  toggleCreate = () => {
    this.setState({ create: !this.state.create });
    this.props.selectAddress(this.props.senderAddress, BILLING);
  };

  validateEmail() {
    dispatch({ type: PURCHASE_LABEL });
    const re = /\S+@\S+\.\S+/;
    const valid = re.test(this.props.userEmail);
    if (!valid) {
      dispatch({
        type: PURCHASE_LABEL_ERROR,
        payload: { errors: "Enter a valid email" },
      });
    }
    return valid;
  }

  async payWithCard(transaction = null) {
    if (!this.validateEmail()) {
      return;
    }
    // Get the token from the response, and send to your server
    // call the back end
    const giftExchangeId =
      this.props.giftExchange && this.props.selectedExchange
        ? this.props.selectedExchange.id
        : "";
    const order_id = this.props.selectedOrder?.external_id || null;
    const payment_method_type = this.state.selectedWallet?.allow_any_balance
      ? BILLED_MANUALLY
      : this.props.paymentCard
        ? this.props.paymentCard.payment_method_type
        : "card";
    if (!!this.props.pendingRatePurchase) {
      this.props.checkPendingRatePurchase(
        this.props.pendingRatePurchase,
        payment_method_type,
        () => {
          this.props.history.replace(this.props.returnURL);
          this.props.clearApplicationContext();
        },
      );
    } else {
      this.props.purchaseRateCard(
        {
          rate: this.props.selectedRate,
          email: this.props.userEmail,
          promo: undefined,
          method: payment_method_type,
          giftExchangeId: giftExchangeId,
          file_type: this.props.fileType,
          order_id,
        },
        this.props.paymentCard,
        transaction,
        this.state.selectedWallet,
        (label) => {
          let searchParam = "";
          if (label) {
            searchParam = `?search=${label.tracking_number || label.id}`;
          }
          this.props.history.replace(`${ROUTES.LABEL}/${searchParam}`);
          this.props.clearApplicationContext();
        },
        () => {
          this.props.getAccounts();
        },
      );
    }
  }

  getButtonText = () => {
    if (!!this.props.pendingRatePurchase) {
      return "Retry";
    }
    if (!!this.state.selectedWallet?.allow_any_balance) {
      return "Generate Label";
    }
    if (this.state.hasEnoughBalance) {
      return "Pay with Wallet Balance";
    }
    if (!this.props.paymentCard) {
      return "Select a payment method";
    }
    if (this.props.paymentCard?.payment_method_type === MPESA) {
      return "Pay with Mobile Money";
    }
    return "Pay with Card";
  };

  renderFileTypes = () => {
    const list = Object.keys(FILETYPES).map((item, idx) => {
      return (
        <Dropdown.Item
          key={idx}
          onClick={() => {
            this.props.updateFileType(item);
          }}
        >
          {FILETYPES[item]}
        </Dropdown.Item>
      );
    });

    return (
      <Dropdown>
        <Dropdown.Toggle className="col-12 p-3 d-flex flex-row justify-content-between align-items-center">
          {FILETYPES[this.props.fileType]}
        </Dropdown.Toggle>
        <Dropdown.Menu>{list}</Dropdown.Menu>
      </Dropdown>
    );
  };

  renderCard = (card) => {
    if (this.state.create) {
      return (
        <CardForm
          onFinish={(id) => {
            this.props.getUserDetails();
            let card = this.props.cardList.find((card) => card.id === id);
            this.props.selectCard(card, CARD_PAY, () => this.toggleCreate());
          }}
          onCancel={this.toggleCreate}
          paystackCharge={{
            onSuccess: (transaction) => {
              this.payWithCard(transaction);
            },
            amount:
              this.props.selectedRate.discounted_amount ||
              this.props.selectedRate.amount,
            currency: this.props.selectedRate.currency,
            loading: this.props.loading || this.props.accountsLoading,
          }}
        />
      );
    } else if (!this.props.accountsLoading) {
      return (
        <Dropdown>
          <div className={"selected-card"}>
            <CardListItem
              card={card}
              type={CARD_PAY}
              onCreate={() => this.toggleCreate()}
            />
          </div>
          <Dropdown.Menu className="card-list col-12 p-0">
            <div className={"create-payment-method"}>
              <button
                className={""}
                onClick={() => {
                  this.toggleCreate();
                }}
              >
                + Add payment method
              </button>
            </div>
            {!this.props.loadCardList ? (
              [
                this.props.cardList.map((item, idx) => {
                  return (
                    <Dropdown.Item className="m-0 p-0" key={item.id}>
                      <CardListItem
                        card={item}
                        key={idx}
                        type={CARD_PAY}
                        select
                      />
                    </Dropdown.Item>
                  );
                }),
              ]
            ) : (
              <div
                className={
                  "d-flex flex-grow-1 justify-content-center align-items-center"
                }
              >
                <div className="spinner-border text-dark m-5" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </Dropdown.Menu>
        </Dropdown>
      );
    }
  };

  renderPaystackAuth = () => {
    const { nextAction, paymentId, errors, loading } = this.props;
    if (!nextAction) return null;

    let title = "";
    let inputBody = null;
    let actionButton = null;

    if (nextAction.type === "redirect") {
      title = "Payment Authorization Required";
      inputBody = (
        <>
          <p className="mb-3">
            Click the button below to complete authorization in a new tab. This
            window will update automatically once you&apos;re done.
          </p>
          <button
            className="pay-with-card col-12 mb-3"
            onClick={() => window.open(nextAction.authorization_url, "_blank")}
          >
            Authorize Payment
          </button>
          {!errors && (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner animation="border" size="sm" className="mr-2" />
              <small className="ml-2">Waiting for authorization&hellip;</small>
            </div>
          )}
        </>
      );
    } else if (nextAction.type === "submit_pin") {
      title = nextAction.display_text || "Enter your card PIN to continue";
      inputBody = (
        <input
          type="password"
          inputMode="numeric"
          maxLength={4}
          placeholder="PIN"
          className="form-control mb-3"
          value={this.state.pinInput}
          onChange={(e) => this.setState({ pinInput: e.target.value })}
        />
      );
      if (!errors) {
        actionButton = (
          <button
            className="pay-with-card col-12"
            disabled={this.state.pinInput.length < 4 || loading}
            onClick={() => {
              this.props.submitPaystackPin(paymentId, this.state.pinInput);
              this.setState({ pinInput: "" });
            }}
          >
            {loading ? <Spinner animation="border" size="sm" /> : "Submit PIN"}
          </button>
        );
      }
    } else if (nextAction.type === "submit_otp") {
      title = nextAction.display_text || "Enter the OTP sent to your phone";
      inputBody = (
        <input
          type="text"
          inputMode="numeric"
          maxLength={6}
          placeholder="OTP"
          className="form-control mb-3"
          value={this.state.otpInput}
          onChange={(e) => this.setState({ otpInput: e.target.value })}
        />
      );
      if (!errors) {
        actionButton = (
          <button
            className="pay-with-card col-12"
            disabled={this.state.otpInput.length < 4 || loading}
            onClick={() => {
              this.props.submitPaystackOtp(paymentId, this.state.otpInput);
              this.setState({ otpInput: "" });
            }}
          >
            {loading ? <Spinner animation="border" size="sm" /> : "Submit OTP"}
          </button>
        );
      }
    }

    if (!inputBody) return null;

    return (
      <div className="modal d-flex zindex-modal justify-content-center align-items-center">
        <div className="backdrop" />
        <Card className="modal-content col-11 col-sm-8 col-md-6 col-xl-4 m-auto p-4">
          <h5 className="mb-3">{title}</h5>
          {inputBody}
          {errors && (
            <MessageBlock
              message={errors}
              type={"error"}
              icon={<FiAlertCircle />}
              className="mb-3"
            />
          )}
          {errors ? (
            <button
              className="pay-with-card col-12"
              onClick={this.retryPurchase}
            >
              Try Again
            </button>
          ) : (
            actionButton
          )}
        </Card>
      </div>
    );
  };

  render() {
    let card = this.props.paymentCard;
    const { balance, currency: walletCurrency } =
      this.state.selectedWallet || {};
    const { currency } = this.props.selectedRate;

    return (
      <>
        <div className="modal label-purchase-modal d-flex zindex-modal justify-content-center justify-content-lg-start aligin-items-center">
          <div
            onClick={() => this.props.toggleModal()}
            className="backdrop"
          ></div>
          <Card className="modal-content purchase-label d-block col-11 col-lg-7 col-xl-5 m-auto ">
            <div className="col-12 p-0 d-flex flex-row justify-content-between">
              <h5>Purchase Label</h5>
              <a className="d-flex" onClick={() => this.props.toggleModal()}>
                Close
              </a>
            </div>
            <LabelSummary showCarriers={this.props.showCarriers} />
            <Card className="my-3 p-3">
              <p>
                This is the email where you'll receive a receipt and all other
                information about your shipping label.
              </p>
              <p className="email">{this.props.userEmail}</p>
            </Card>
            <Card className="filetypes my-3 p-3">
              <p>Select the type of file you what to print for the label</p>
              {this.renderFileTypes()}
            </Card>

            {!this.state.selectedWallet?.allow_any_balance && (
              <Card className="card-selection my-3 p-3">
                <div>
                  <p>
                    Payment
                    <ToolTip
                      keyValue={"label-payment-wallet"}
                      className={"label-payment-wallet-tooltip"}
                      placement={"auto"}
                      message={
                        "The wallet is always the default payment method. If the balance is insufficient, it will be topped up and then the payment will be processed."
                      }
                    />
                  </p>
                </div>
                <div
                  className={
                    "wallet-balance d-flex w-100 flex-row align-items-center justify-content-between"
                  }
                >
                  <h4 className={"info mb-0"}>Wallet Balance</h4>
                  {this.props.accountsLoading ? (
                    <Spinner animation={"border"} size={"sm"} />
                  ) : (
                    <p className={"mb-0"}>
                      {!!this.state.selectedWallet
                        ? toMoneyFormat(balance, walletCurrency)
                        : `${currency} 0`}
                    </p>
                  )}
                </div>
                {!this.state.hasEnoughBalance && (
                  <div>
                    <MessageBlock
                      type={"error"}
                      message={
                        "You don't have enough balance in your wallet to pay. please select a payment method to top up your wallet."
                      }
                    />
                    {this.renderCard(card)}
                  </div>
                )}
              </Card>
            )}
            <div className="my-3">
              {this.props.errors && (
                <MessageBlock
                  message={this.props.errors}
                  type={"error"}
                  icon={<FiAlertCircle />}
                />
              )}
              {!this.state.create && !this.props.nextAction ? (
                <button
                  className="pay-with-card col-12"
                  onClick={() => {
                    this.payWithCard();
                  }}
                  disabled={
                    this.props.loading ||
                    this.props.accountsLoading ||
                    (!this.state.selectedWallet?.allow_any_balance &&
                      !this.state.hasEnoughBalance &&
                      !this.props.paymentCard &&
                      !this.props.pendingRatePurchase)
                  }
                >
                  {this.props.loading || this.props.accountsLoading ? (
                    <Spinner animation={"border"} />
                  ) : (
                    this.getButtonText()
                  )}
                </button>
              ) : null}
            </div>
          </Card>
        </div>
        {this.renderPaystackAuth()}
      </>
    );
  }
}

const mapStateToProps = ({
  userDetails,
  purchaseLabel,
  rateChoices,
  stores,
  applicationContext,
  wallets,
  senderAddress,
}) => ({
  defaultCard: userDetails.defaultCard,
  paymentCard: userDetails.paymentCard,
  cardList: userDetails.cards,
  loadCardList: userDetails.loading || userDetails.defaultLoading,
  info: userDetails.info,
  userEmail: purchaseLabel.userEmail,
  selectedRate: rateChoices.selectedRate,
  loading: purchaseLabel.loading,
  errors: purchaseLabel.errors,
  fileType: purchaseLabel.fileType,
  nextAction: purchaseLabel.nextAction,
  paymentId: purchaseLabel.paymentId,
  selectedOrder: stores.selectedOrder,
  returnURL: applicationContext.context.returnURL,
  authType: applicationContext.context.auth,
  pendingRatePurchase: purchaseLabel.label,
  accounts: wallets.accounts,
  accountsLoading: wallets.loading,
  senderAddress,
  defaultAddress: userDetails.info?.default_address,
});

export default withRouter(
  connect(mapStateToProps, {
    selectCard,
    getUserDetails,
    purchaseRateCard,
    updatePurchaseEmail,
    updateFileType,
    clearApplicationContext,
    checkPendingRatePurchase,
    clearPurchaseStates,
    getAccounts,
    selectAddress,
    submitPaystackPin,
    submitPaystackOtp,
  })(PurchaseLabel),
);
